import { render, staticRenderFns } from "./GlobalAllergens.vue?vue&type=template&id=2a3b0c94"
import script from "./GlobalAllergens.vue?vue&type=script&lang=ts"
export * from "./GlobalAllergens.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports